/**
 * React Query hooks for admin trial management (list, reset).
 */

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  adminListTrials,
  adminResetTrial,
  type AdminListTrialsResponse,
  type AdminResetTrialResponse,
} from "../services/naraDoor";

/** List all trials (admin view). */
export function useTrials() {
  return useQuery<AdminListTrialsResponse>({
    queryKey: ["adminTrials"],
    queryFn: () => adminListTrials(),
  });
}

/**
 * Mutation to hard-delete a single trial by workspace ID.
 * On success, invalidates the trial list.
 */
export function useResetTrial() {
  const queryClient = useQueryClient();

  return useMutation<AdminResetTrialResponse, Error, string>({
    mutationFn: (workspaceId) => adminResetTrial(workspaceId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["adminTrials"] });
    },
  });
}
